import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import pageStyle from "../../pages/Pages.module.css";
import styles from "./HorasReport.module.css";
import tableStyle from "../../components/Table/Table.module.css";
import Button from "../Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";
import { baseURL } from "../utils/utils";
import { useAuthContext } from "../../hooks/useAuthContext";
import Input from "../Input/Input";
import Checkbox from "../Checkbox/Checkbox";

const HorasReport = () => {
  const { user } = useAuthContext();
  const { httpRequest } = useFetch(`${baseURL}/report/`);
  const location = useLocation();
  const navigate = useNavigate();
  const contentRef = useRef();
  const [dadosTabela, setTabela] = useState([]);

  const [total, setTotal] = useState(0);
  const [relNome, setRelNome] = useState("Relação de horas consultores");
  const [showValues, setShowValues] = useState(false);
  const [showValorHora, setShowValHora] = useState(false);
  const [valTot, setValTot] = useState("");

  useEffect(() => {
    const data = location.state?.filteredItems;

    data && buscaReport(data);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buscaReport = async (data) => {
    const dados = await httpRequest(data, user.token, `apontamentos`);

    calculaTotal(dados);
    setTabela(dados);
  };
  const calculaTotal = (dados) => {
    let total = 0;
    dados?.forEach((item) => {
      total += item.valor;
    });
    setTotal(total);
    // console.log(total);
  };

  const gerarPDF = async () => {
    const canvas = await html2canvas(contentRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait", // "landscape" para horizontal
      unit: "mm",
      format: "a4"
    });

    // Pegando a largura e altura do PDF
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Pegando a largura e altura da imagem gerada pelo canvas
    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    // Calculando a proporção para ajustar a imagem no PDF
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const imgScaledWidth = imgWidth * ratio;
    const imgScaledHeight = imgHeight * ratio;

    pdf.addImage(
      imgData,
      "PNG",
      10,
      10,
      imgScaledWidth - 20,
      imgScaledHeight - 20
    );
    pdf.save(`relatorio_${relNome}.pdf`);
  };
  //******************************* */
  // Formatar como hh:mm
  const decimalToHours = (decimal) => {
    const hours = Math.floor(decimal); // Parte inteira: horas
    const minutes = Math.round((decimal - hours) * 60); // Parte decimal convertida em minutos
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };
  //******************************* */
  // Formatar como DD/MM/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const retValorHora = (row) => {
    return Number(row.valor / row.horas).toFixed(2);
  };
  return (
    <div className={pageStyle.container}>
      <div className={styles.InputContainer}>
        {user.fk_NivId < 2 && (
          <div>
            <Input
              label="Descrição do relatório"
              id="RelNome"
              type="text"
              value={relNome && relNome}
              onChange={(e) => {
                setRelNome(e.target.value);
              }}
              active="true"
            />
            <Input
              label="Valor total"
              id="valTot"
              type="text"
              value={valTot}
              onChange={(e) => {
                setValTot(e.target.value);
              }}
              active="true"
            />
            <div className={styles.checkbox_container}>
              <Checkbox
                checked={showValorHora}
                label="Mostrar valor/hora"
                onChange={(e) => setShowValHora(e.target.checked)}
              />{" "}
              <Checkbox
                checked={showValues}
                label="Mostrar valores"
                onChange={(e) => setShowValues(e.target.checked)}
              />
            </div>
          </div>
        )}
      </div>

      <div className={styles.card} ref={contentRef}>
        <h1 className={pageStyle.title}>Relação de horas consultores</h1>
        <table className={`${tableStyle.table}`}>
          <thead>
            <tr className={tableStyle.tr}>
              <th className={tableStyle.th}>Consultor</th>
              <th className={tableStyle.th}>Tarefa</th>
              <th className={tableStyle.th}>Detalhe</th>
              <th className={`${tableStyle.th} ${tableStyle.centro}`}>Data</th>
              <th className={`${tableStyle.th} ${tableStyle.direita}`}>
                Horas
              </th>
              {showValorHora && (
                <th className={`${tableStyle.th} ${tableStyle.direita}`}>
                  Valor/h
                </th>
              )}
              {showValues && (
                <th className={`${tableStyle.th} ${tableStyle.direita}`}>
                  Valor
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {dadosTabela &&
              dadosTabela.map((row, index) => {
                return (
                  <tr key={index} className={styles.tr}>
                    <td className={tableStyle.td}>{row.consultor}</td>
                    <td className={`${tableStyle.td} ${styles.tarefa}`}>
                      {row.tarefa}
                    </td>
                    <td className={`${tableStyle.td} ${styles.obs}`}>
                      {row.observacoes}
                    </td>
                    <td className={`${tableStyle.td} ${tableStyle.center}`}>
                      {formatDate(row.data)}
                    </td>
                    <td className={`${tableStyle.td} ${tableStyle.center}`}>
                      {decimalToHours(row.horas)}
                    </td>
                    {showValorHora && (
                      <td className={`${tableStyle.td} ${tableStyle.right}`}>
                        {retValorHora(row)}
                      </td>
                    )}
                    {showValues && (
                      <td className={`${tableStyle.td} ${tableStyle.right}`}>
                        {Number(row.valor).toFixed(2)}
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
        <div className={styles.total}>
          <label>
            Valor total R${" "}
            {valTot ? Number(valTot).toFixed(2) : total.toFixed(2)}
          </label>
        </div>
      </div>
      <div className={styles.card}>
        <Button texto="Gerar PDF" onClick={gerarPDF} active={true} />
        <Button
          texto="Cancelar"
          onClick={() => navigate("/registros")}
          active={true}
        />
      </div>
    </div>
  );
};

export default HorasReport;
